import React, { useContext, useMemo } from 'react';
import { useRequest } from 'ahooks';
import styles from './index.module.scss';
import { Empty, Tooltip } from '@maxtropy/components';
import { Progress, Spin } from 'antd';
import classNames from 'classnames';
import { apiV2EnergyOverviewGetAreaAlarmRankingPost } from '@maxtropy/device-customer-apis-v2';
import device_rank_icon from '../../../../../../imgs/menu-片区@2x.png';
import titlePng from '@/assets/images/title_icon.png';
import { ShareDataUnityEnergyCockpitMapContext } from '../../../..';
import { getDefaultTime } from '@/pages/WgqAllMaps/utils';
import SubTitle from '@/pages/WgqAllMaps/components/SubTitle';
import { useAutoLoopSelect } from '../../../../hook';
import { isNil } from 'lodash-es';

const EachAreaAlarmRanking = () => {
  const { timeResolution, dateValue } = useContext(ShareDataUnityEnergyCockpitMapContext);

  // 区域报警排名
  const { data: alarmRankingData, loading } = useRequest(
    async () => {
      return await apiV2EnergyOverviewGetAreaAlarmRankingPost({
        timeResolution,
        fromTime: getDefaultTime(timeResolution!, dateValue)?.startTime,
        toTime: getDefaultTime(timeResolution!, dateValue)?.endTime,
      });
    },
    {
      refreshDeps: [timeResolution, dateValue],
      ready: !!timeResolution && !!dateValue,
    }
  );

  const { selectedId, onItemMouseEnter, onItemMouseLeave } = useAutoLoopSelect({
    list: alarmRankingData?.list ?? [],
    interval: 3000,
    getId: item => item.labelId!,
  });

  return (
    <SubTitle title="各区域报警排名" img={titlePng} headerStyle={{ paddingBottom: 8 }}>
      <Spin spinning={loading}>
        {!alarmRankingData?.list || alarmRankingData?.list?.length === 0 ? (
          <Empty style={{ marginTop: 60 }} />
        ) : (
          <div className={styles.top_rank_list_wrapper}>
            {alarmRankingData.list?.map((item, index) => (
              <div
                key={item.labelId}
                onMouseLeave={onItemMouseLeave}
                onMouseEnter={() => onItemMouseEnter(index)}
                className={classNames(styles.top_rank_list_item, selectedId === item.labelId && styles.selected)}
              >
                <span className={styles.rank_num}>{index + 1}</span>
                <img className={styles.rank_icon} src={device_rank_icon} alt="" />
                {/* <Tooltip
                  title={`报警数：${item.count ?? '--'}`}
                  open={selectedId === item.labelId}
                  mouseEnterDelay={0}
                  mouseLeaveDelay={0}
                > */}
                <span className={styles.device_name}>{item.labelName}</span>
                {/* </Tooltip> */}
                <div className={styles.progress}>
                  <Progress
                    percent={
                      isNil(alarmRankingData.list![0].count)
                        ? 0
                        : ((item.count ?? 0) / alarmRankingData.list![0].count!) * 100
                    }
                    showInfo={false}
                    size="small"
                    strokeColor={'#FF4D4F'}
                  />
                </div>
                <span className={styles.alarm_num}>{item.count}</span>
              </div>
            ))}
          </div>
        )}
      </Spin>
    </SubTitle>
  );
};

export default EachAreaAlarmRanking;
